export default __webpack_public_path__ + "static/header-top-desktop-64732c3024cac1fb4886799422f68734.svg";